
export default {
  props: {
    page: {
      type: Object,
      default: null
    }
  },
  vessel: {
    container: {
      backgroundPosition: 'center',
      backgroundSize: 'cover'
    },
    box: {
      padding: 'md',
      shadow: 'md',
      xl: {
        padding: 'lg',
      }
    },
    whiteBox: {
      $extend: 'box',
      backgroundColor: 'white',
      paddingX: 'md',
      xl: {
        paddingX: 'xl'
      }
    },
    blackBox: {
      $extend: 'box',
      height: 'full',
      backgroundColor: 'black',
      color: 'white'
    },
    redBox: {
      $extend: 'blackBox',
      backgroundColor: 'primary',
      textAlign: 'center'
    }
  },
  data() {
    return {
      image: true
    }
  },
  computed: {
    sectionStyle() {
      return this.image ? { backgroundColor: 'rgba(215,11,54,0.7)' } : null
    },
    tileStyle() {
      return this.image ? { backgroundColor: 'rgba(0,0,0,0.6)' } : null
    },
    headerStyle() {
      return this.image ? { backgroundImage: `url("${this.page.image}")` } : null
    }
  }
}
